var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropDownArrow = function SvgDropDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "drop-down-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h10v10H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#drop-down-arrow_svg__a)",
    "data-name": "Scroll Group 1",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "M5 7.271a.657.657 0 0 1-.465-.193L1.191 3.72a.657.657 0 1 1 .93-.928l2.878 2.89 2.879-2.89a.657.657 0 1 1 .931.927L5.466 7.077A.657.657 0 0 1 5 7.271Z",
    "data-name": "Path 52"
  }))));
};
export default SvgDropDownArrow;